import { schema } from "normalizr";

//const campaignSchema = new schema.Entity('campaign', {}, {idAttribute: '_id'});
const campaignSchema = new schema.Entity(
  "campaign",
  {},
  {
    idAttribute: value => (value._id ? value._id : "current")
  }
);
const campaignsSchema = new schema.Array(campaignSchema);

const contentSchema = new schema.Entity("content", {}, { idAttribute: "_id" });
const contentsSchema = { content: new schema.Array(contentSchema) };

const channelSchema = new schema.Entity("channel", {}, { idAttribute: "_id" });
const channelsSchema = new schema.Array(channelSchema);

const prizeSchema = new schema.Entity("prize", {}, { idAttribute: "_id" });
const prizesSchema = new schema.Array(prizeSchema);

const productSchema = new schema.Entity("product", {}, { idAttribute: "_id" });
const productsSchema = new schema.Array(productSchema);

const productCategorySchema = new schema.Entity("productCategory", {}, { idAttribute: "_id" });
const productCategoriesSchema = new schema.Array(productCategorySchema);

const productDescriptionSchema = new schema.Entity(
  "productDescription",
  {},
  { idAttribute: "_id" }
);
const productDescriptionsSchema = new schema.Array(productDescriptionSchema);

const regionSchema = new schema.Entity("region", {}, { idAttribute: "_id" });
const regionsSchema = new schema.Array(regionSchema);

const teamSchema = new schema.Entity("team", {}, { idAttribute: "_id" });
const teamsSchema = new schema.Array(teamSchema);

const transactionSchema = new schema.Entity("transaction", {}, { idAttribute: "_id" });
const transactionsSchema = new schema.Array(transactionSchema);

const userSchema = new schema.Entity("user", {}, { idAttribute: "_id" });
const usersSchema = new schema.Array(userSchema);

const topSellerSchema = new schema.Entity("topSeller", {}, { idAttribute: "_id" });
const topSellersSchema = new schema.Array(topSellerSchema);

campaignSchema.define({
  previousCampaign: campaignSchema,
  nextCampaign: campaignSchema
});

channelSchema.define({
  adminUser: userSchema
});

productCategorySchema.define({
  descriptions: productDescriptionsSchema
});

productSchema.define({
  channel: channelSchema,
  productCategory: productCategorySchema,
  team: teamSchema
});

regionSchema.define({
  adminUser: userSchema,
  channel: channelSchema,
  teams: teamsSchema
});

teamSchema.define({
  adminUser: userSchema,
  channel: channelSchema,
  members: usersSchema,
  region: regionSchema
});

transactionSchema.define({
  product: productSchema
});

const topTeamSchema = new schema.Entity(
  "ranking",
  {},
  {
    idAttribute: (value, parent, key) => {
      return value.team._id;
    }
  }
);
const topTeamsSchema = new schema.Array(topTeamSchema);

topTeamSchema.define({
  team: teamSchema,
  channel: channelSchema
});

userSchema.define({
  channel: channelSchema,
  region: regionSchema,
  team: teamSchema
});

const authResponseSchema = new schema.Values(
  {
    user: userSchema
  },
  (input, parent, key) => {
    return `${key}`;
  }
);

export default {
  authResponseSchema,
  campaignSchema,
  campaignsSchema,
  contentSchema,
  contentsSchema,
  channelSchema,
  channelsSchema,
  prizeSchema,
  prizesSchema,
  productSchema,
  productsSchema,
  productCategorySchema,
  productCategoriesSchema,
  regionSchema,
  regionsSchema,
  teamSchema,
  teamsSchema,
  topTeamSchema,
  topTeamsSchema,
  transactionSchema,
  transactionsSchema,
  userSchema,
  usersSchema,
  topSellersSchema
};



// WEBPACK FOOTER //
// ./src/api/schema.js